import fetch from '@/api/fetch';

const commonParams = {
  sysParam: {
    appKey: 1213,
    format: 'JSON',
    locale: 'zh_CN',
    sign: 'ajsdfkjdlkfgjl;kwjdfg',
  },
};

// 资产查询列表
export default function shopList(id = '') {
  return fetch({
    url: '/baccount/workbench/employee/shoplist',
    method: 'post',
    data: { ...commonParams, id },
  });
}
